module.exports = __webpack_public_path__ + "img/registrations.16db0689.svg";